// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4124":"ca73557a","4206":"fb46db24","5528":"b1694579","7463":"7190a847","8688":"c558803c"}[chunkId] + ".chunk.css";
};